import Component from './Component';
import { hasError, showError, removeError } from './../services/FormValidation';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

 let newForm;
 let links = [];
 let init = 0;




/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */

 function spliceArray (arr, id) {
    for (let i = 0 ; i < arr.length; i++) {
        if (arr[i] == id) {
            arr.splice(i, 1);
            break;
        }
    }

    return arr;
}





/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class AddLink extends Component {

    decorator () {
        return {
            selector : '.js-add-link',
            name : 'AddLink',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        if (this.list.innerHTML == '') { return; }

        this.bindElements();
    }


    cacheElements () {
        this.list = this.element.querySelector('.js-add-link-list');
        // this.item = Array.from(this.list.querySelector('.js-add-link-item'));
        this.btn = this.element.querySelector('.js-add-link-btn');
        this.maxUpload = this.element.getAttribute('data-upload-max');
        this.elms = this.element.getElementsByTagName('input');
        this.hidden = this.elms[0];
        this.link = this.elms[1];

        this.btn.addEventListener('click', e => {
            e.preventDefault();

            let error = hasError(this.link);

            if (error) {
                showError(this.elms, this.link, error);
                return;
            }

            if (this.link.value == '') { return; }

            removeError(this.elms, this.link);

            this.addLink(this.link.value);
        });
    }


    bindElements () {
        if (this.hidden.value == '') { return; }

        let newArr = JSON.parse(this.hidden.value);

        links = newArr;

        init = links.length;

        this.setMaxLimit();

        this.item = Array.from(this.list.querySelectorAll('.js-add-link-item'));


        this.item.forEach((item, idx) => {
            const remove = item.querySelector('.js-add-link-remove');
            const name = item.getAttribute('data-link');

            remove.addEventListener('click', e => {
                item.classList.remove('is-added');
                let spliced = spliceArray(links, name);
                init--;
                this.hidden.value = '';
                this.hidden.value = JSON.stringify(spliced);

                this.setMaxLimit();

                setTimeout(() => {
                    item.remove();
                }, 500);
            });
        })
    }



    addLink (link) {
        let newItem = document.createElement('li');
        newItem.setAttribute('data-link', link);
        newItem.className = 'o-add-link__item js-add-link-item'
        let newName = document.createElement('span');
        newName.className = 'o-add-link__name';
        newName.innerText = link;

        init++;

        let newControls = `<div class="o-add-link__ctrls">
                <a href="javascript:;" title="" class="js-add-link-remove">
                    <span class="o-icon">
                        <svg><use xlink:href="#close"></use></svg>
                    </span>
                </a>
            </div>`;

        links.push(this.link.value);

        this.hidden.value = '';
        this.hidden.value = JSON.stringify(links);

        newItem.innerHTML = newControls;
        newItem.appendChild(newName);
        this.list.appendChild(newItem);
        this.link.value = '';

        this.setMaxLimit();

        const remove = newItem.querySelector('.js-add-link-remove');
        const name = newItem.getAttribute('data-link');

        setTimeout(() => {
            newItem.classList.add('is-added');
        }, 350);

        // remove link
        remove.addEventListener('click', e => {

            newItem.classList.remove('is-added');

            let spliced = spliceArray(links, name);

            init--;

            this.hidden.value = '';
            this.hidden.value = JSON.stringify(spliced);

            this.setMaxLimit();

            setTimeout(() => {
                newItem.remove();
            }, 500);
        })
    }


    setMaxLimit () {
        if (init >= this.maxUpload) {
            this.btn.setAttribute('disabled', '');
            this.link.setAttribute('disabled', '');
        } else {
            this.btn.removeAttribute('disabled');
            this.link.removeAttribute('disabled');
        }
    }
}
